import { memo } from 'react';

import IconWarning from '@assets/images/icons/icon-warning-orange.svg';

import { BLOCKED_NOTICE_STRINGS } from './utils/blocked-notice.constants';

import type { TBlockedNoticeConfig } from './blocked-notice.types';

import * as S from './blocked-notice.styles';

const BlockedNotice = memo(({ isSellingTab }: TBlockedNoticeConfig) => {
	const message = isSellingTab
		? BLOCKED_NOTICE_STRINGS.BLOCKED_SELLING_MESSAGE
		: BLOCKED_NOTICE_STRINGS.BLOCKED_BUYING_MESSAGE;

	return (
		<S.Container data-testid="blocked-notice" data-qa="blocked-notice">
			<img src={IconWarning} alt={BLOCKED_NOTICE_STRINGS.WARNING_ICON_ALT} />
			<p>{message}</p>
		</S.Container>
	);
});

BlockedNotice.displayName = 'BlockedNotice';
export { BlockedNotice };
